/* eslint-disable */
import storage from "utils/storage";

const asyncEvery = async <T>(
  array: T[],
  callback: (value: T, index: number, a: T[]) => Promise<boolean>
): Promise<boolean> => {
  for (let i = 0; i < array.length; i++) {
    const result = await callback(array[i], i, array);
    if (!result) {
      return result;
    }
  }
  return true;
};

export const canAccess = async (
  permissionsMenu?: string[] | undefined,
  userPermissionsMenu?: string[]
): Promise<boolean> => {
  if (!permissionsMenu) {
    return true;
  }

  if (!userPermissionsMenu) {
    return false;
  }
  const result = await asyncEvery<string>(
    permissionsMenu,
    async (permission) => {
      return userPermissionsMenu.indexOf(`${permission}`) >= 0;
    }
  );

  return result;
};

export const canAccessV2 = (
  permissionsMenu?: string[] | undefined,
  userPermissionsMenu?: string[]
): boolean => {
  if (!permissionsMenu) {
    return true;
  }

  if (!userPermissionsMenu) {
    return false;
  }
  const result = permissionsMenu.every((e) => {
    return userPermissionsMenu.indexOf(`${e}`) >= 0;
  });

  return result;
};

export const getCanAccess = (permissionMenu?: string[] | undefined) => {
  let isCanAccess = false;

  const userPermissionsMenu = storage.getPermissionsMenu();

  const result = canAccessV2(permissionMenu, userPermissionsMenu);
  if (result !== undefined && result !== null) {
    isCanAccess = result;
  }
  return isCanAccess;
};
